import {Flow} from 'flow-to-typescript-codemod';
import * as React from 'react';
import {Input as InputField} from 'src/designSystem2021Components/input';
import type {Props} from 'src/designSystem2021Components/input';
import {Smallest} from 'src/designSystem2021Components/text-v2';

import css from './input.css';


export const Input = (
  props: Props &
    Omit<
      Omit<
        Flow.ComponentProps<typeof InputField>,
        | 'disabled'
        | 'name'
        | 'placeholder'
        | 'boxClassName'
        | 'value'
        | 'onChange'
        | 'onFocus'
        | 'onBlur'
        | 'error'
        | 'errorText'
        | 'label'
        | 'className'
      >,
      keyof Props
    >,
) => {
  const {
    value,
    onChange,
    onFocus,
    onBlur,
    name,
    disabled,
    placeholder,
    error,
    errorText,
    label,
    contextLabel,
    boxClassName,
    ...inputProps
  } = props;

  return (
    <InputField
      disabled={disabled}
      name={name}
      placeholder={placeholder}
      boxClassName={boxClassName}
      value={value}
      onChange={onChange}
      onFocus={onFocus}
      onBlur={onBlur}
      error={error}
      errorText={errorText}
      label={<Smallest className={css.labelClass}>{label}</Smallest>}
      {...inputProps}
    />
  );
};
